/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as MenuDefault } from './menu-default.story';
export { default as MenuNested } from './menu-nested.story';
export { default as MenuWithCategory } from './menu-with-category.story';
export { default as MenuWithIcon } from './menu-with-icon.story';
export { default as MenuCustomItems } from './menu-custom-items.story';
export { default as MenuInPopover } from './menu-in-popover.story';
export { default as MenuInDialog } from './menu-in-dialog.story';
export { default as MenuDivider } from './menu-with-divider.story';
export { default as MenuWithDisabledItem } from './menu-with-disabled-item.story';
export { default as MenuPlacements } from './menu-placements.story';
export { default as MenuWithKeyboardDisplay } from './menu-with-keyboard-shortcuts.story';
export { default as MenuRadioItems } from './menu-radio-items.story';
export { default as MenuRadioAndNormal } from './menu-radio-and-normal.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import MenuCustomItemsSrcRaw from './menu-custom-items.story?raw';
import MenuDefaultSrcRaw from './menu-default.story?raw';
import MenuInDialogSrcRaw from './menu-in-dialog.story?raw';
import MenuInPopoverSrcRaw from './menu-in-popover.story?raw';
import MenuNestedSrcRaw from './menu-nested.story?raw';
import MenuPlacementsSrcRaw from './menu-placements.story?raw';
import MenuRadioAndNormalSrcRaw from './menu-radio-and-normal.story?raw';
import MenuRadioItemsSrcRaw from './menu-radio-items.story?raw';
import MenuWithCategorySrcRaw from './menu-with-category.story?raw';
import MenuWithDisabledItemSrcRaw from './menu-with-disabled-item.story?raw';
import MenuDividerSrcRaw from './menu-with-divider.story?raw';
import MenuWithIconSrcRaw from './menu-with-icon.story?raw';
import MenuWithKeyboardDisplaySrcRaw from './menu-with-keyboard-shortcuts.story?raw';

export const MenuDefaultSrc = removeLicenseHeader(MenuDefaultSrcRaw);
export const MenuNestedSrc = removeLicenseHeader(MenuNestedSrcRaw);
export const MenuWithCategorySrc = removeLicenseHeader(MenuWithCategorySrcRaw);
export const MenuWithIconSrc = removeLicenseHeader(MenuWithIconSrcRaw);
export const MenuCustomItemsSrc = removeLicenseHeader(MenuCustomItemsSrcRaw);
export const MenuInPopoverSrc = removeLicenseHeader(MenuInPopoverSrcRaw);
export const MenuInDialogSrc = removeLicenseHeader(MenuInDialogSrcRaw);
export const MenuDividerSrc = removeLicenseHeader(MenuDividerSrcRaw);
export const MenuWithDisabledItemSrc = removeLicenseHeader(
  MenuWithDisabledItemSrcRaw,
);
export const MenuPlacementsSrc = removeLicenseHeader(MenuPlacementsSrcRaw);
export const MenuWithKeyboardDisplaySrc = removeLicenseHeader(
  MenuWithKeyboardDisplaySrcRaw,
);
export const MenuRadioItemsSrc = removeLicenseHeader(MenuRadioItemsSrcRaw);
export const MenuRadioAndNormalSrc = removeLicenseHeader(
  MenuRadioAndNormalSrcRaw,
);
